/**
 * Analiz geçişinde module-level harita state'ini temizle.
 * Layer Manager Analysis temizliğiyle birlikte çalışır.
 *
 * Yalnızca haritaya bakan ref'ler ve bayraklar sıfırlanır. Sahiplerin sonuç
 * verisi (koridor listesi, alan bbox'ı, SA/TD önbellekleri, izokron özellikleri)
 * korunur; sahip geri gelince restore() ile yeniden basılır.
 */
import {
  adminIlceGeojson,
  adminMahalleGeojson,
  catchmentGeojson,
  corridorAreaGeojson,
  corridorAreaMode,
  corridorGeojson,
  isochroneMode,
  mapDimGtfsStops,
  mapLayerAdminCoverage,
  mapLayerCatchment,
  mapLayerCorridor,
  mapLayerCorridorArea,
  mapLayerIlceBoundaries,
  mapLayerIsochrone,
  mapLayerSaBuffers,
  mapLayerServiceAvailability,
  mapLayerTransitDesert,
  serviceAvailabilityBuffersGeojson,
  serviceAvailabilityStopsGeojson,
  transitDesertGeojson,
} from '@/composables/gtfs/useAnalizMapLayers.js'

export function clearLegacyAnalysisMapState() {
  catchmentGeojson.value = { type: 'FeatureCollection', features: [] }
  corridorGeojson.value = { type: 'FeatureCollection', features: [] }
  serviceAvailabilityStopsGeojson.value = {
    type: 'FeatureCollection',
    features: [],
  }
  serviceAvailabilityBuffersGeojson.value = {
    type: 'FeatureCollection',
    features: [],
  }
  transitDesertGeojson.value = { type: 'FeatureCollection', features: [] }
  adminMahalleGeojson.value = { type: 'FeatureCollection', features: [] }
  adminIlceGeojson.value = { type: 'FeatureCollection', features: [] }
  corridorAreaGeojson.value = { type: 'FeatureCollection', features: [] }
  corridorAreaMode.value = false
  isochroneMode.value = false

  mapLayerIsochrone.value = false
  mapLayerCatchment.value = false
  mapLayerCorridor.value = false
  mapLayerCorridorArea.value = false
  mapLayerSaBuffers.value = false
  mapLayerServiceAvailability.value = false
  mapLayerAdminCoverage.value = false
  mapLayerTransitDesert.value = false
  mapLayerIlceBoundaries.value = false
  mapDimGtfsStops.value = false
}
